export const routes = [
  {
    path: "/",
    redirect: {
      name: "Index",
    },
  },
  {
    path: "/index.php",
    redirect: {
      name: "Index",
    },
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/Login.vue"),
    meta: {
      authRequired: false,
    },
  },
  {
    path: "/test",
    name: "Test",
    component: () => import("@/views/Test.vue"),
    meta: {
      authRequired: false,
    },
  },
  {
    path: "/index",
    name: "Index",
    component: () => import("@/views/repair/Index.vue"),
  },
  {
    path: "/create",
    name: "Create",
    component: () => import("@/views/Create.vue"),
  },
  {
    path: "/detail/:id",
    name: "Detail",
    component: () => import("@/views/detail/Detail"),
  },
];
